'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { Box } from '@s7/base';
import { rem } from '@s7/styles';
import { Divider } from '@s7/ui';

var styles = function(theme) {
    var _obj;
    return _obj = {
        padding: "0 " + rem(24)
    }, _obj[theme.fn.up("md1")] = {
        padding: "0 " + rem(40)
    }, _obj;
};
var SearchLayoutDivider = function() {
    return /*#__PURE__*/ jsx(Box, {
        sx: styles,
        children: /*#__PURE__*/ jsx(Divider, {})
    });
};

export { SearchLayoutDivider };
